import { Recurso } from "lib.common/dist/CleanArch";
import { PaginationOptions } from "lib.common/dist/types";
import { ProductoDsTiendaDtSource } from "../../business/dataSources/ProductoDsTiendaDtSource";
import { ProductoDsTienda } from "../../business/entities/ProductoDsTienda";
import { ErrExterno } from "lib.common/dist/errorHandler";
import { transformacion } from "lib.common/dist";
import { apiDsTienda } from "src/config/keys";

export class ProductoDsTiendaDtSourceImpl implements ProductoDsTiendaDtSource {
    async getAllProductosDsTienda(pagination?: PaginationOptions, selectList?: string[], onlyDen?: boolean): Promise<Recurso<ProductoDsTienda[]>> {
        try {
            let url = transformacion.appendUrl(apiDsTienda, '/producto/all');
            const params = new URLSearchParams();
            if (pagination) params.append('pagination', pagination.toString());
            if (selectList?.length) params.append('selectList', selectList.join(','));
            params.append('onlyDen', String(onlyDen));
            url.search = params.toString();
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de los productos de DsTienda.');
            }
            const {data} = await response.json();
            return Recurso.fromData<ProductoDsTienda[]>(data);
        } catch (error) {
            return Recurso.fromError<ProductoDsTienda[]>(new ErrExterno(error as Error));
        }
    }

}